/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PostBulkBillingReportsZipRequestBody,
  PostBulkBillingReportsZipRequestBodyFromJSON,
  PostBulkBillingReportsZipRequestBodyToJSON,
} from "../models";

export interface PostBulkBillingReportsZipRequest {
  postBulkBillingReportsZipRequestBody: PostBulkBillingReportsZipRequestBody;
}

/**
 *
 */
export class BulkBillingReportApi extends runtime.BaseAPI {
  /**
   * Generate the billing reports (chain usage summary CSV and pharmacy usage summary CSV) of all bulk billing target chains for the billing month and return them as one ZIP. Only when every chain succeeds. If any chain fails, returns 502 with JSON {code, message, report_id, failed: [{chain_id, chain_name, failed_step, message}]} and no ZIP
   */
  async postBulkBillingReportsZipRaw(
    requestParameters: PostBulkBillingReportsZipRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Blob>> {
    if (
      requestParameters.postBulkBillingReportsZipRequestBody === null ||
      requestParameters.postBulkBillingReportsZipRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "postBulkBillingReportsZipRequestBody",
        "Required parameter requestParameters.postBulkBillingReportsZipRequestBody was null or undefined when calling postBulkBillingReportsZip."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/bulk-billing-reports.zip`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostBulkBillingReportsZipRequestBodyToJSON(requestParameters.postBulkBillingReportsZipRequestBody),
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Generate the billing reports (chain usage summary CSV and pharmacy usage summary CSV) of all bulk billing target chains for the billing month and return them as one ZIP. Only when every chain succeeds. If any chain fails, returns 502 with JSON {code, message, report_id, failed: [{chain_id, chain_name, failed_step, message}]} and no ZIP
   */
  async postBulkBillingReportsZip(
    requestParameters: PostBulkBillingReportsZipRequest,
    initOverrides?: RequestInit
  ): Promise<Blob> {
    return promiseRetry(
      (retry) =>
        this.postBulkBillingReportsZipRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
